import React, { useState } from "react";
import ContentHeader from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import ComingSoon from "../../components/ComingSoon";
import "./../Expenses/Expenses.css";
import SearchContent from "../../components/Search-comp/SearchContent";
import SearchNavigation from "../../components/Search-comp/SearchNavigation";
import ChalanNavigation from "../../components/ChalanBook/ChalanNavigation";
import ChalanContent from "../../components/ChalanBook/ChalanContent";

const ChalanBook = () => {
  const [isActive, setIsActive] = useState(false);

  return (
    <div className="col-md-12 content">
      <Sidebar
        className="sidebar-main"
        isActive={isActive}
        setIsActive={setIsActive}
        classNameTwo="open-sidebar"
      />
      <div className="col-12 sb-content">
        <div className="sb-content-header">
          <ContentHeader setIsActive={setIsActive} />
        </div>
        <div className="sb-nav">
          <ChalanNavigation />
        </div>
        <div className="content-index">
          <ChalanContent />
        </div>
      </div>
    </div>
  );
};

export default ChalanBook;
